import Vue from 'vue'
import router from './router'
import VueMeta from 'vue-meta'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import VueCookie from 'vue-cookie'
import mobileMenu from '@/components/mobileMenu'
import headerMenu from '@/components/headerMenu'
import footerMenu from '@/components/footerMenu'
import modals from '@/components/modals'
import VueI18n from 'vue-i18n'
import axios from '@/router/http'

Vue.config.productionTip = false
Vue.use(Loading)
Vue.use(VueCookie)
Vue.use(VueI18n)
Vue.use(VueMeta, {refreshOnceOnNavigation: true})
Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})
let handleOutsideClick
Vue.directive('closable', {
  bind (el, binding, vnode) {
    handleOutsideClick = (e) => {
      e.stopPropagation()
      const { handler, exclude } = binding.value
      let clickedOnExcludedEl = false
      exclude.forEach(refName => {
        if (!clickedOnExcludedEl) {
          const excludedEl = vnode.context.$refs[refName]
          clickedOnExcludedEl = excludedEl.contains(e.target)
        }
      })
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        vnode.context[handler]()
      }
    }
    document.addEventListener('click', handleOutsideClick)
    document.addEventListener('touchstart', handleOutsideClick)
  },
  unbind () {
    document.removeEventListener('click', handleOutsideClick)
    document.removeEventListener('touchstart', handleOutsideClick)
  }
})
Vue.component('mobile-menu', mobileMenu)
Vue.component('header-menu', headerMenu)
Vue.component('footer-menu', footerMenu)
Vue.component('modals', modals)

/* eslint-disable no-new */
/* eslint-disable handle-callback-err */
new Vue({
  el: '#app',
  metaInfo: {
    title: '— быстро доставляем вкусную еду',
    titleTemplate: 'Хочу поесть %s',
    description: 'description',
    htmlAttrs: {
      lang: 'ru'
    },
    meta: [
      {property: 'og:title', name: 'og:title', content: 'Хочу Поесть: быстро доставляем вкусную еду'},
      {vmid: 'description', name: 'description', property: 'description', content: 'Доставка еды из лучших ресторанов в городе. Бесплатная доставка суши, роллов, пиццы, бургеров и еще 1000 блюд без комиссии и наценок. Реальные 200 рублей, а не бонусов за регистрацию. Акции и скидки из всех ресторанов на одном сайте.'},
      {property: 'keywords', content: 'сайт доставки еды , сервисы доставки еды , служба доставки еды , быстрая доставка еды доставка , быстрая доставка пиццы , доставка блюд , доставка бургеров , доставка вкусной еды доставка готовой еды на дом , доставка десертов , доставка домашней еды , доставка еды доставка еды в офис ,доставка еды домой , доставка еды из ресторанов , доставка из ресторанов доставка на дом , доставка на дом еды , доставка обедов в офис , доставка обедов на дом, доставка пиццы и суши , доставка пиццы на дом , доставка продуктов , доставка роллов доставка суши и пиццы , еда в офис , еда домой , еда доставка , еда доставка на дом заказ блюд на дом , заказ еды в офис , заказ еды домой , заказ еды из ресторана заказ еды с доставкой , заказ на дом , заказ обедов , заказ обедов в офис, заказ продуктов , заказать еду в офис , заказать еду из ресторана , заказать еду с доставкой заказать обед , заказать обед в офис , заказать пиццу , заказать пиццу и суши заказать пиццу онлайн , заказать покушать , заказать роллы , заказать роллы на дом купить пиццу , лучшая доставка пиццы , обед в офис , обеды в офис , обеды на дом пицца доставка , пицца заказать , пицца и суши , пицца на заказ , пицца с доставкой пицца суши , продукты на дом , роллы заказать ,роллы на дом , роллы на заказ роллы с доставкой , суши заказать на дом , суши и роллы , суши на заказ , суши пицца суши пицца доставка , суши роллы доставка , суши с доставкой , заказ напитков заказ десертов , заказ пирогов , заказать блюда гриль'},
      {property: 'og:image', content: 'https://хочу-поесть.рф/static/img/restrunt_card/header/top_line_logo.svg'},
      {property: 'twitter:image:src', content: 'https://хочу-поесть.рф/static/img/restrunt_card/header/top_line_logo.svg'},
      {property: 'og:site_name', content: 'Хочу Поесть: быстро доставляем вкусную еду'}
    ]
  },
  data: {
    city: {id: null, name: null, country_name: null},
    hideAll: 0,
    cat: {img: null, title: null},
    auth: {language: 'ru', country: 'Россия', setNewAdr: 0},
    mapinit: 0,
    geo: {
      lat2: null,
      lng2: null,
      lat: null,
      lng: null,
      city: null,
      address: null
    },
    user: {},
    basketUpdate: 0,
    basket: {
      basket: {},
      amount: 0,
      valute: 'руб.'
    },
    modals: null,
    modalsData: null,
    geocoder: null,
    autocomplete: null,
    outside: -1,
    showMap: false
  },
  router,
  created () {
    var hostname = window.location.hostname
    var hostnameforcookie
    if (hostname !== 'localhost') {
      hostname = hostname.split('.')
      if (hostname.length === 3) hostnameforcookie = hostname[1] + '.' + hostname[2]
      else hostnameforcookie = hostname[0] + '.' + hostname[1]
    } else {
      hostnameforcookie = 'localhost'
      hostname = 'localhost'
    }
    var uid = this.$cookie.get('uid')
    var city = this.$cookie.get('city')
    if (uid) this.auth.uid = uid
    if (city) this.city = city
    if (!this.auth.uid) {
      let code = this.$route.params.code
      axios.get((code !== undefined ? 'https://lk.when-hungry.com/mobile/get-mobile?code=' + code : 'https://lk.when-hungry.com/mobile/get-mobile'), {crossDomain: true, headers: {'Access-Control-Allow-Origin': '*'}}).then(response => {
        if (response.data.status === 'new') {
          this.auth = response.data.new
          this.$cookie.set('uid', this.auth.uid, {expires: '1Y', domain: hostnameforcookie})
        } else this.auth = response.data
        this.myLocation()
      })
    } else {
      axios.get('https://lk.when-hungry.com/mobile/get-mobile?uid=' + this.auth.uid, {crossDomain: true, headers: {'Access-Control-Allow-Origin': '*'}}).then(response => {
        this.auth = response.data
        this.user = response.data.users
        this.city.name = this.auth.city
        this.city.country_name = this.auth.country
        this.geo.city = this.auth.city
        this.geo.lat = this.auth.lat
        this.geo.lng = this.auth.lng
        this.geo.lat2 = this.auth.lat
        this.geo.lng2 = this.auth.lng
        this.geo.address = this.auth.address
        if (this.geo.lat && this.geo.lng) {
          this.mapinit = 1
        } else this.myLocation()
      })
    }
  },
  methods: {
    sendTokenToServer (token) {
      var formData = new FormData()
      formData.append('push', token)
      formData.append('uid', this.auth.uid)
      axios.post('https://lk.when-hungry.com/mobile/put-mobile',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
    },
    myLocation () {
      navigator.geolocation.getCurrentPosition((position) => {
        var city
        var country
        let json
        if (typeof google === 'undefined') window.location = '/'
        this.geocoder = new google.maps.Geocoder()
        this.geocoder.geocode({
          'location': {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
        }, (results, status) => {
          if (status === 'OK') {
            if (results[0]) {
              json = this.getAddress(results[0].address_components)
              city = json.city
              country = json.country
              // if (this.isMobile() && country === this.city.country_name) {
              // }
              if (!this.auth.init_city && city !== this.city.name && country === this.city.country_name) {
                if (confirm('Ваша геолокация определяет город ' + city + ', а вы находитесь на сайте города ' + this.city.name + ', поменять город?')) {
                  this.geo.city = city
                  this.city.name = city
                  this.geo.address = json.address
                  this.geo.lat = position.coords.latitude
                  this.geo.lng = position.coords.longitude
                  this.mapinit = 1
                  if (this.isMobile) this.showMap = true
                } else {
                  alert('Вы отказались от смены города, геолокация выключена.')
                  this.geocoder.geocode({
                    'address': this.city.name
                  }, (results, status) => {
                    if (results[0]) {
                      json = this.getAddress(results[0].address_components)
                      this.geo.lat = results[0].geometry.location.lat()
                      this.geo.lng = results[0].geometry.location.lng()
                      this.geo.address = json.address
                      this.mapinit = 1
                      if (this.isMobile) this.showMap = true
                    }
                  })
                }
              } else if (this.city.name === city) {
                this.geo.address = json.address
                this.geo.lat = position.coords.latitude
                this.geo.lng = position.coords.longitude
                this.mapinit = 1
                if (this.isMobile) this.showMap = true
              } else this.mapinit = 1
            }
          }
        })
      }, (error) => {
        setTimeout(() => {
          this.myLocation()
        }, 1000)
      })
    },
    alert (mes) {
      alert(mes)
    },
    getAddress (adr) {
      let city
      let i
      let country
      var componentForm = {
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name'
      }
      var componentsForms = []
      for (i = 0; i < adr.length; i++) {
        var addressType = adr[i].types[0]
        if (addressType === 'locality') city = adr[i]['long_name']
        if (addressType === 'country') country = adr[i]['long_name']
        if (componentForm[addressType]) {
          componentsForms[addressType] = adr[i][componentForm[addressType]]
        }
      }
      if (city === 'Київ') city = 'Киев'
      if (city === 'Днипро') city = 'Днепр'
      if (city === 'Дніпро́') city = 'Днепр'
      if (city === 'Одеса' || city === undefined || city === '') {
        for (i = 0; i < adr.length; i++) {
          if (adr[i].types[0] === 'political' || adr[i].types[0] === 'administrative_area_level_1') city = adr[i]['long_name']
        }
      }
      let address = [
        ([componentsForms['route'], componentsForms['street_number']].join(' ') === ' ' ? ', ' : [componentsForms['route'], componentsForms['street_number']].join(' ')),
        componentsForms['administrative_area_level_1'],
        componentsForms['locality']
      ].join(', ').replaceAll(', , , ', '').replaceAll(', , ', '').replaceAll(', ,', ',')
      return {city: city, country: country, address: address}
    },
    hideModal () {
      this.outside++
      if (this.outside > 0) {
        // this.modals = null
        this.outside = -1
      }
    },
    isMobile () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    saveData (key, value) {
      var formData = new FormData()
      formData.append(key, value)
      formData.append('uid', this.auth.uid)
      axios.post('https://lk.when-hungry.com/mobile/put-mobile',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        this.auth = response.data
      })
    },
    initMes () {
      if ('Notification' in window) {
        var messaging = firebase.messaging()
        messaging.usePublicVapidKey('BOy4yRWpOEXNtmol7hbN3YkYeCFPm0qyTpB0aOelwNv9JSkHsWSwA3b4fg7Brqb7zGxCMojkxMnMnYYdrMvvmmU')
        if (Notification.permission === 'granted') {
          messaging.onTokenRefresh(() => {
            messaging.getToken().then((refreshedToken) => {
              console.log('Token refreshed.')
              this.sendTokenToServer(refreshedToken)
            }).catch((err) => {
              console.warn('При получении токена произошла ошибка.', err)
            })
          })
          messaging.getToken()
            .then((currentToken) => {
              console.log(currentToken)

              if (currentToken) {
                this.sendTokenToServer(currentToken)
              } else {
                console.warn('Не удалось получить токен.')
              }
            })
            .catch((err) => {
              console.warn('При получении токена произошла ошибка.', err)
            })
          messaging.onMessage((payload) => {
            console.log('Message received. ', payload)
          })
        } else if (Notification.permission !== 'denied') {
          Notification.requestPermission().then((permission) => {
            // If the user accepts, let's create a notification
            if (permission === 'granted') {
              messaging.getToken()
                .then((currentToken) => {
                  console.log(currentToken)

                  if (currentToken) {
                    this.sendTokenToServer(currentToken)
                  } else {
                    console.warn('Не удалось получить токен.')
                  }
                })
                .catch((err) => {
                  console.warn('При получении токена произошла ошибка.', err)
                })
            }
          })
        }
      }
      var head = document.getElementsByTagName('head')[0]
      var script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = 'https://cdn.envybox.io/widget/cbk.js?wcb_code=463ddfa79368844a2c36acec6f89c3bc'
      head.appendChild(script)
    }
  },
  watch: {
    'auth.uid' (val, oldVal) {
      if (val && val !== oldVal) {
        console.table({
          new: val,
          old: oldVal
        })
        if (firebase.apps.length === 0 || firebase === undefined || firebase.apps === undefined) {
          var firebaseConfig = {
            apiKey: 'AIzaSyDPAsm046-14StMZIOp9qr_zVZB6IkAcdc',
            authDomain: 'whenhungry-a85ed.firebaseapp.com',
            databaseURL: 'https://whenhungry-a85ed.firebaseio.com',
            projectId: 'whenhungry-a85ed',
            storageBucket: 'whenhungry-a85ed.appspot.com',
            messagingSenderId: '900555041435',
            appId: '1:900555041435:web:dd512e1e1089559afeb43e',
            measurementId: 'G-LFY7ZXFCQB'
          }
          firebase.initializeApp(firebaseConfig)
          this.initMes()
        } else this.initMes()
      }
    },
    'auth.city' (val) {
      this.city.name = val
    },
    'city.name' (val, old) {
      if (val !== this.auth.city) {
        this.saveData('city', val)
      }
      if (val !== old) {
        axios.get('https://lk.when-hungry.com/mobile/get-city?city=' + val + '&country=' + this.auth.country, {crossDomain: true, headers: {'Access-Control-Allow-Origin': '*'}}).then(response => {
          this.city = response.data
          this.basketUpdate = 1
        })
      }
    },
    basketUpdate (val) {
      if (val) {
        axios.get('https://lk.when-hungry.com/mobile/get-basket?uid=' + this.auth.uid).then(response => {
          this.basket = response.data
          let basket = this.basket.basket
          let errors = 0
          for (let restaurantId in basket) {
            if (parseInt(basket[restaurantId].minimal) > parseInt(basket[restaurantId].amount)) errors++
          }
          this.basket.errors = errors
        })
        this.basketUpdate = 0
      }
    },
    $route (to, from) {
      this.hideAll = 0
      this.cat = {img: null, title: null}
    }
  }
})
// eslint-disable-next-line
String.prototype.replaceAll = function (search, replace) {
  return this.split(search).join(replace)
}
let loader
router.beforeEach((to, from, next) => {
  if (to.name) {
    loader = Vue.$loading.show({
      loader: 'dots',
      opacity: 0.8,
      backgroundColor: 'transparent',
      color: '#54BB65',
      isFullPage: true
    })
  }
  next()
})

router.afterEach((to, from) => {
  loader.hide()
})



// WEBPACK FOOTER //
// ./src/main.js